import { render, staticRenderFns } from "./DeductionsPlanFloatBtns.vue?vue&type=template&id=01f40515&"
import script from "./DeductionsPlanFloatBtns.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports